<template>
  <a ref="card" :href="link" class="glassy-card" :class="[align, { visible: isVisible }]">
    <div class="card-images">
      <img :src="image" alt="card image" />
    </div>
  </a>
</template>

<script>
export default {
  name: 'GlassyCard',
  props: {
    image: { type: String, required: true },
    link: { type: String, default: '#' },
    align: { type: String, default: 'left' }
  },
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      {
        threshold: 0.2
      }
    );
    this.observer.observe(this.$refs.card);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.glassy-card {
  width: 100%;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px;
  opacity: 0;
  transition: opacity 0.8s ease 0.2s, transform 0.8s cubic-bezier(0.25, 1, 0.5, 1) 0.2s;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.8);
  text-decoration: none;
}
.glassy-card.left {
  left: 105%;
  transform: translateY(0) translateX(40px);
}

.glassy-card.right {
  right: 105%;
  text-align: left;
  transform: translateY(0) translateX(-40px);
}

.glassy-card.visible {
  opacity: 1;
  transform: translateY(0) translateX(0);
}
.glassy-card.visible {
  opacity: 1;
}

.card-images img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

@media (max-width: 768px) {
  .glassy-card {
    text-align: center;
  }

  .glassy-card.left,
  .glassy-card.right {
    transform: translateY(30px);
    text-align: center;
  }

  .glassy-card.visible {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
